module.exports = {
  "country": "CH",
  "artist": "Sebalter ",
  "song": "Hunter of Stars",
  "year": "2014",
  "place": "13",
  "spotify": "5pX8S6xCA08WHIbddDnGRP"
};